export default __webpack_public_path__ + "static/media/ctaImg.30711533.png";